/**
 * Konverterar ett axios-fel till ett läsbart meddelande.
 * Hanterar både string-detaljer (FastAPI HTTPException) och array-detaljer
 * (Pydantic 422 validation errors) som annars renderas som [object Object].
 */
export function formatApiError(err, fallback = "Något gick fel, försök igen") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        const field = Array.isArray(d?.loc) ? d.loc.filter((x) => x !== "body").join(".") : "";
        const msg = d?.msg || "ogiltigt värde";
        return field ? `${field}: ${msg}` : msg;
      })
      .join(" · ");
  }
  return fallback;
}
